"use strict";

export default {
  FILTER: "46894aa3-d06e-19b5-e053-d8d5a8c084fd",
  STRUKTUR: "46894aa3-d06d-19b5-e053-d8d5a8c084fd",
  AUSSCHLUSS: "46894aa3-d06c-19b5-e053-d8d5a8c084fd",
};
